/**
 * Enumeration of analysis types to differentiate business cases related to interactions with another applications, like Cockpit (ShiftHandover...) or so.
 * @export
 * @enum {string}
 */
export enum EventEditModeEnum {
  SINGLE = 'single',
  SINGLE_IN_SERIES = 'singleInSeries',
  SERIES = 'series'
}

export type EventEditModes = 'single' | 'singleInSeries' | 'series'
